import { Modal, Persona, PersonaSize, Checkbox } from '@fluentui/react';
import { Col, Divider, Row, List, message } from 'antd';
import React, { useContext } from 'react';
import { useState } from 'react';
import ButtonBack from '../../components/ButtonBack/ButtonBack';
import ButtonDefault from '../../components/ButtonDefault/ButtonDefault';
import FieldDropdown from '../../components/FieldDropdown/FieldDropdown';
import FieldText from '../../components/FieldText/FieldText';
import SetupAdd from '../../components/SetupAdd/SetupAdd';
import SetupTitle from '../../components/SetupTitle/SetupTitle';
import SetupTitleDesc from '../../components/SetupTitleDesc/SetupTitleDesc';
import SetupTitleMini from '../../components/SetupTitleMini/SetupTitleMini';
import { UserContext } from '../../context/UserContext';
import LogoWhite from '../../svg/LogoWhite';
import FieldDeleteIcon from '../../svg/FieldDeleteIcon';
import moment from 'moment';
import { API } from '../../API/API';
import LoadSpin from '../../components/LoadSpin/LoadSpin';
import { Fragment } from 'react';
import TermsConditions from './TermsConditions';

const InitSetupPage = (props) => {

    const { userInfo } = useContext(UserContext);

    const [loadingSave, setLoadingSave] = useState(false);
    const [step, setStep] = useState(0);
    const [data, setData] = useState([
        {
            key: 0,
            text: "",
            placeholder: "Удирдлагын хэлтэс...",
            pos: [
                {
                    key: 0,
                    text: '',
                    emp: [],
                    parentkey: 0
                },
                {
                    key: 1,
                    text: '',
                    emp: [],
                    parentkey: 0
                }
            ]
        },
        {
            key: 1,
            text: "",
            placeholder: 'Санхүүгийн хэлтэс...',
            pos: [
                {
                    key: 2,
                    text: '',
                    emp: [],
                    parentkey: 1
                },
                {
                    key: 3,
                    text: '',
                    emp: [],
                    parentkey: 1
                }
            ]
        }
    ]);

    const [initEmp] = useState({
        empid: 0,
        regno: "",
        lastname: "",
        firstname: "",
        posid: -1
    })
    const [emp, setEmp] = useState({ ...initEmp });

    const [step2FocusIndex, setStep2FocusIndex] = useState();
    const [step3DKey, setStep3DKey] = useState(1);

    const [terms, setTerms] = useState(false);

    const onAddDep = () => {
        let tData = [...data];
        let lastIndex = Math.max(...tData?.map(r => r.key)) + 1;
        let childLastIndex = Math.max(...tData?.map(r => r.pos).flat()?.map(r => r.key));
        tData.push({
            key: lastIndex,
            text: "",
            pos: [
                {
                    key: childLastIndex + 1,
                    text: '',
                    emp: [],
                    parentkey: lastIndex
                },
                {
                    key: childLastIndex + 2,
                    text: '',
                    emp: [],
                    parentkey: lastIndex
                }
            ]
        });
        setData(tData);
    }

    const onAddPos = (pKey) => {

        let tData = [...data];
        let tIndex = tData?.map(r => r.key).indexOf(pKey);
        if (tIndex >= 0) {
            let lastIndex = Math.max(...tData?.map(r => r.pos).flat()?.map(r => r.key)) + 1;

            tData[tIndex].pos.push({
                key: lastIndex,
                text: '',
                emp: [],
                parentkey: pKey
            });
            setStep2FocusIndex(lastIndex);
        }
        setData(tData);
    }

    const nextStep = async () => {
        let vRule = true;

        if (step == 0) {
            try {
                setLoadingSave(true);
                await API.post("/api/humanresource/Organization/setTermsConditions").then(response => {
                });
            } finally {
                setLoadingSave(false);
            }
        } else if (step == 1) {
            let tData = data.filter(r => r.text);
            if (tData.length == 0) {
                vRule = false;
            }
        } else if (step == 2) {
            let tData = data?.map(r => r.pos).flat().filter(r => r.text);
            if (tData.length == 0) {
                vRule = false;
            }
        }

        if (vRule) {
            setStep(r => r + 1);
        } else {
            message.warning("Бүртгэл дутуу байна.");
        }
    }

    const prevStep = () => {
        setStep(r => r - 1);
    }

    const onChangeDep = (pKey, pValue) => {
        let tData = [...data];
        let pIndex = tData?.map(r => r.key).indexOf(pKey);
        if (pIndex >= 0) {
            tData[pIndex].text = pValue;
        }
        setData(tData);
    }

    const onDelDep = (pKey) => {
        let tData = [...data];
        if (tData?.length > 1) {
            let pIndex = tData?.map(r => r.key).indexOf(pKey);
            if (pIndex >= 0) {
                tData?.splice(pIndex, 1);
            }
            setData(tData);
        }
    }

    const onChangePos = (pParentKey, pKey, pValue) => {
        let tData = [...data];
        let tParentIndex = tData?.map(r => r.key).indexOf(pParentKey);
        if (tParentIndex >= 0) {
            let tIndex = tData[tParentIndex].pos?.map(r => r.key).indexOf(pKey);
            if (tIndex >= 0) {
                tData[tParentIndex].pos[tIndex].text = pValue;
            }
        }
        setData(tData);
    }

    const onDelPos = (pParentKey, pKey) => {
        let tData = [...data];
        let tParentIndex = tData?.map(r => r.key).indexOf(pParentKey);
        if (tParentIndex >= 0) {
            let tIndex = tData[tParentIndex].pos?.map(r => r.key).indexOf(pKey);
            if (tIndex >= 0) {
                let tPos = [...tData[tParentIndex].pos];
                tPos.splice(tIndex, 1);
                tData[tParentIndex].pos = tPos;
            }
        }
        setData(tData);
    }

    const onChangeEmp = (key, text, field, fieldname) => {
        if (field) {
            let tEmp = { ...emp };
            tEmp[field] = key;
            if (fieldname) {
                tEmp[fieldname] = text;
            }
            setEmp(tEmp);
        }
    }

    const onAddEmp = () => {

        let vRule = true;
        let vMessage = "";

        if (!emp?.regno) {
            vRule = false
            vMessage = "Регистрийн дугаар талбарын утга хоосон байна!";
        }

        if (vRule && emp?.posid >= 0) {

            let tPos = data?.map(r => r.pos).flat().find(r => r?.key == emp?.posid);
            if (tPos) {

                let tParentIndex = data?.map(r => r.key).indexOf(tPos.parentkey);
                let tIndex = data[tParentIndex]?.pos?.map(r => r.key).indexOf(tPos.key);

                if (tParentIndex >= 0 && tIndex >= 0) {
                    let tData = [...data];
                    if (emp?.empid == 0) {
                        tData[tParentIndex].pos[tIndex].emp.push({
                            ...emp,
                            empid: moment().unix()
                        });
                    } else {
                        let tEmpIndex = tData[tParentIndex].pos[tIndex].emp?.map(r => r.empid).indexOf(emp?.empid);
                        if (tEmpIndex >= 0) {
                            tData[tParentIndex].pos[tIndex].emp[tEmpIndex] = { ...emp };
                        }
                    }
                    setData(tData);
                    setEmp({ ...initEmp });
                    setStep3DKey(r => r = r + 1);
                }
            }
        } else {
            message.warning(vMessage);
        }
    }

    const onEditEmp = (pEmpId) => {
        if (pEmpId) {
            let tDataEmp = data?.map(r => r.pos)?.flat()?.map(r => r.emp)?.flat();
            if (tDataEmp?.length > 0) {
                let tIndex = tDataEmp?.map(r => r.empid)?.indexOf(pEmpId);
                if (tIndex >= 0) {
                    setEmp(tDataEmp[tIndex]);
                }
            }
        }
    }

    const onFinish = async () => {

        setLoadingSave(true);

        try {
            await API.post('/api/humanresource/Organization/save_company_structure', data).then(response => {
                if (response.status === 200 && response.data.rettype === 0) {
                    message.success("Амжилтай");
                }
            });
        } finally {
            setLoadingSave(false);
        }

        props?.afterSave();
    }

    let vPanel = null;

    if (step == 0) {
        vPanel = (
            <Fragment>
                <SetupTitle>Үйлчилгээний нөхцөл</SetupTitle>
                <div style={{ margin: '30px 0px 30px 0px', border: '1px solid #CDCDCD', height: '60vh', overflow: 'auto', background: '#F7F7F7', borderRadius: 2, padding: 16 }}>
                    <TermsConditions />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Checkbox onChange={() => { setTerms(r => !r); }} />
                        <div style={{ fontSize: 14, color: '#201F1E', marginLeft: 8 }}>Үйлчилгээний нөхцлийг зөвшөөрч байна.</div>
                    </div>
                    {loadingSave ? <LoadSpin /> : <ButtonDefault disabled={!terms} onClick={nextStep} text="Үргэлжлүүлэх" />}
                </div>
            </Fragment>
        )
    } else if (step == 1) {
        vPanel = (
            <Fragment>
                <SetupTitle>Байгууллагын бүтэц</SetupTitle>
                <SetupTitleDesc>Байгууллагын дотоод нэгж оруулна уу.</SetupTitleDesc>
                <div style={{ margin: '30px 0px 30px 0px', minWidth: 300 }}>
                    {data?.map((r, index) => {
                        return (
                            <div key={index} style={{ marginBottom: 16 }}>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ flex: 1 }}>
                                        <FieldText autoFocus={((data?.length == 2 && index == 0) || (data?.length > 2 && index + 1 == data?.length)) ? true : false} placeholder={r?.placeholder} onChanged={(value) => onChangeDep(r?.key, value)} keyfield='depname' defaultValue={r?.text} onEnterClicked={onAddDep} />
                                    </div>
                                    {data?.length > 1 && (
                                        <FieldDeleteIcon onClick={() => onDelDep(r?.key)} />
                                    )}
                                </div>
                            </div>
                        );
                    })}
                    <SetupAdd onClick={onAddDep}>Дотоод нэгж нэмэх</SetupAdd>
                </div>
                <ButtonDefault onClick={nextStep} text="Үргэлжлүүлэх" />
            </Fragment>
        )
    } else if (step == 2) {
        vPanel = (
            <Fragment>
                <SetupTitle>Ажлын байр</SetupTitle>
                <SetupTitleDesc>Дотоод нэгжид харьяалагдах ажлын байрыг оруулна уу.</SetupTitleDesc>
                <div style={{ margin: '30px 0px 30px 0px', minWidth: 300 }}>
                    {data?.map((r, index) => {
                        if (r?.text) {
                            return (
                                <div key={index} style={{ marginBottom: 16 }}>
                                    <SetupTitleMini>{r?.text}</SetupTitleMini>
                                    <div style={{ marginTop: 12 }}>
                                        {r?.pos?.map((ri, riindex) => {
                                            return (
                                                <div key={riindex} style={{ marginBottom: 16 }}>
                                                    <div style={{ display: 'flex' }}>
                                                        <div style={{ flex: 1 }}>
                                                            <FieldText autoFocus={((index == 0 && riindex == 0) || ri?.key == step2FocusIndex) ? true : false} placeholder="Ажлын байрны нэр" onChanged={(value) => onChangePos(r?.key, ri?.key, value)} keyfield='posname' defaultValue={ri?.text} />
                                                        </div>
                                                        {r?.pos?.length > 1 && (
                                                            <FieldDeleteIcon onClick={() => onDelPos(r?.key, ri?.key)} />
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <SetupAdd onClick={() => onAddPos(r?.key)}>Ажлын байр нэмэх</SetupAdd>
                                </div>
                            );
                        }
                    })}
                </div>
                <div style={{ display: 'flex', justifyContent: "space-between" }}>
                    <ButtonBack onClick={prevStep} text="Буцах" />
                    <ButtonDefault onClick={nextStep} text="Үргэлжлүүлэх" />
                </div>
            </Fragment>
        )
    } else if (step == 3) {
        vPanel = (
            <Fragment>
                <SetupTitle>Ажилтан</SetupTitle>
                <SetupTitleDesc>Байгууллагын ажилтнуудаа нэмнэ үү.</SetupTitleDesc>
                <div style={{ margin: '30px 0px 30px 0px', minWidth: 300 }}>
                    <div key={step3DKey} style={{ marginBottom: 16 }}>
                        <FieldText autoFocus={true} title="Регистрийн дугаар" onChanged={onChangeEmp} keyfield='regno' defaultValue={emp?.regno} />
                    </div>
                    <div style={{ marginBottom: 16 }}>
                        <FieldText title="Овог" onChanged={onChangeEmp} keyfield='lastname' defaultValue={emp?.lastname} />
                    </div>
                    <div style={{ marginBottom: 16 }}>
                        <FieldText title="Нэр" onChanged={onChangeEmp} keyfield='firstname' defaultValue={emp?.firstname} />
                    </div>
                    <div style={{ marginBottom: 16 }}>
                        <FieldDropdown disable={emp?.empid > 0 ? true : false} title="Ажлын байр" onChanged={onChangeEmp} keyfield='posid' keyfieldname="posname" defaultValue={emp?.posid} data={data?.map(r => [{ key: (r.key + 100000), text: r.text, itemType: 2 }, ...r?.pos]).flat()?.filter(r => r?.text)} />
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
                    <ButtonBack onClick={prevStep} text="Буцах" />
                    <ButtonDefault onClick={onAddEmp} text="Ажилтан нэмэх" />
                </div>
                <div style={{ marginTop: 32, marginBottom: 32, borderBottom: '1px solid #DADADA' }}>
                </div>
                <div>
                    {loadingSave ? (
                        <LoadSpin />
                    ) : (
                        <ButtonDefault disabled={data?.map(r => r.pos).flat().filter(r => r.text)?.map(r => r.emp).flat().length > 0 && !emp?.regno ? false : true} color="#3E2FA0" full onClick={onFinish} text="Бүртгэл дуусгах" />
                    )}
                </div>
            </Fragment>
        )
    }

    return (
        <Modal
            isOpen={props?.isOpen}
            onDismiss={() => { }}
            containerClassName={{
                borderRadius: 8
            }}
        >
            <div style={{ height: '95vh', width: '95vw', display: 'flex' }}>
                <div style={{ flex: 2, overflow: 'auto' }}>
                    <div className='setupLeftPanel' style={{ minHeight: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 'auto' }}>
                        {step == 3 ? (
                            <div style={{ background: '#FFFFFF', padding: 16, borderRadius: 8 }}>
                                <SetupTitle>{userInfo?.companyname} ажилтны мэдээлэл ({data?.map(r => r.pos)?.flat()?.map(r => r?.emp)?.flat().length})</SetupTitle>
                                {data?.map((r, index) => {
                                    if (!r?.text) {
                                        return null;
                                    }

                                    let tEmp = [];
                                    if (r?.pos?.length > 0) {
                                        tEmp = r?.pos?.map(ri => ri.emp).flat();
                                    }

                                    return (
                                        <div key={index} style={{ marginTop: 30 }}>
                                            <SetupTitle small>{r?.text}</SetupTitle>
                                            <Divider />
                                            <List
                                                grid={{
                                                    gutter: [16, 16],
                                                    xs: 2,
                                                    sm: 2,
                                                    md: 2,
                                                    lg: 2,
                                                    xl: 2,
                                                    xxl: 2,
                                                }}
                                                locale={{ emptyText: "Ажилтан нэмээгүй байна" }}
                                                dataSource={tEmp}
                                                renderItem={(ri) => {
                                                    return (
                                                        <div onClick={() => onEditEmp(ri?.empid)}>
                                                            <Persona
                                                                initialsColor={"#237DDB"}
                                                                text={ri?.firstname}
                                                                secondaryText={ri?.posname}
                                                                size={PersonaSize.size40}
                                                            />
                                                        </div>
                                                    );
                                                }}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div style={{ textAlign: 'center' }}>
                                <LogoWhite />
                                <div style={{ fontWeight: 600, fontSize: 20, color: '#FFFFFF', marginTop: 34 }}>
                                    Бидэнтэй нэгдсэнд баярлалаа.
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div style={{
                    flex: 3,
                    overflow: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 16
                }}> {
                        step > 0 ? (
                            <div style={{ maxWidth: 400, margin: 'auto' }}>
                                {vPanel}
                            </div>
                        ) : (
                            <div style={{ flex: 1 }}>
                                {vPanel}
                            </div>
                        )
                    }
                </div>
            </div>
        </Modal >
    );
}

export default InitSetupPage;